import React from 'react';
import PropTypes from 'prop-types';

const GreenTickSmall = ({ fill = '', dimension = '', className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={dimension || '14'}
    height={dimension || '14'}
    viewBox="0 0 14 14"
    fill="none"
    className={className}
  >
    <circle cx="7" cy="7" r="7" fill={fill || 'var(--SUCCESS_STATUS)'} />
    <path
      d="M9.6034 4.56528L5.84793 8.05153L4.67562 6.82455C4.3842 6.5195 3.90066 6.50844 3.5956 6.79986C3.29054 7.09128 3.27949 7.57483 3.57091 7.87988L5.26442 9.65264C5.55296 9.95468 6.03059 9.96895 6.33664 9.68467L10.6431 5.68468C10.9522 5.39756 10.9701 4.91422 10.683 4.60511C10.3958 4.296 9.91251 4.27816 9.6034 4.56528Z"
      fill="white"
    />
  </svg>
);

GreenTickSmall.propTypes = {
  fill: PropTypes.string,
  dimension: PropTypes.string,
  className: PropTypes.string,
};

export default GreenTickSmall;
